class ProductModal {
    constructor(card, cart) {
        this.handleCardNumberValueTimers = new Map();
        this.enforceCardLimitsTimers = new Map();
        this.initialize(card, cart);
    }

    initialize(card, cart) {
        const modalButton = card.querySelector('.product-card__click');
        const modal = document.querySelector(`#${modalButton.getAttribute('aria-controls')}`);
        const closeButton = modal.querySelector('.product-modal__close');
        const numberField = modal.querySelector('.product-modal__amount-field');
        const overlay = document.querySelector('.product-modal-overlay');
        const increaseButton = modal.querySelector('.product-modal__amount-button.product-modal__amount-button--more');
        const decreaseButton = modal.querySelector('.product-modal__amount-button.product-modal__amount-button--less');
        const expandableButtons = [...modal.querySelectorAll('.product-modal__expandable-button')];
        const addToCartModalButton = modal.querySelector('.product-modal__action.product-modal__action--cart');
        const addToCartCardButton = card.querySelector('.product-card__action.product-card__action--cart')
        const cardDecreaseButton = card.querySelector('.product-card__amount-button--less');
        const cardIncreaseButton = card.querySelector('.product-card__amount-button--more');
        const cardNumberField = card.querySelector('.product-card__amount-field');

        modalButton.addEventListener('click', () => this.toggleModal(modal, closeButton, numberField, modalButton, overlay));
        closeButton.addEventListener('click', () => this.toggleModal(modal, modalButton, numberField, modalButton, overlay));

        expandableButtons.forEach((expandableButton) => {
            expandableButton.addEventListener('click', () => {
                this.handleExpandableButtonOnClick(expandableButton);
            });
        });

        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && modal.classList.contains('product-modal--visible')) {
                this.toggleModal(modal, modalButton, numberField, modalButton, overlay);
            }
        });

        if (addToCartModalButton) {
            addToCartModalButton.addEventListener('click', () => this.addToCart(modal.dataset.productid, numberField, cardNumberField, numberField.value, null, addToCartModalButton));
        }

        if (addToCartCardButton) {
            addToCartCardButton.addEventListener('click', () => this.addToCart(modal.dataset.productid, cardNumberField, numberField, 1, card, addToCartModalButton));
        }

        if (numberField) {
            numberField.addEventListener('input', () => this.enforceLimits(numberField));
            numberField.addEventListener('change', () => this.enforceLimits(numberField));
        }

        if (increaseButton && decreaseButton) {
            increaseButton.addEventListener('click', () => this.handleNumberValue(numberField, cardNumberField, true, card, modal.dataset.productid));
            decreaseButton.addEventListener('click', () => this.handleNumberValue(numberField, cardNumberField, false, card, modal.dataset.productid));
        }

        if (cardIncreaseButton && cardDecreaseButton) {
            cardIncreaseButton.addEventListener('click', () => this.handleCardNumberValue(card, numberField, cardNumberField, true, modal.dataset.productid));
            cardDecreaseButton.addEventListener('click', () => this.handleCardNumberValue(card, numberField, cardNumberField, false, modal.dataset.productid));
        }

        if (cardNumberField) {
            cardNumberField.addEventListener('input', () => this.enforceCardLimits(card, cardNumberField, modal.dataset.productid));
            cardNumberField.addEventListener('change', () => this.enforceCardLimits(card, cardNumberField, modal.dataset.productid));
        }

        if (`#${modal.dataset.productid}` === location.hash) {
            this.toggleModal(modal, closeButton, numberField, modalButton, overlay)
        }

        this.setStatus(card, cart, modal.dataset.productid, addToCartCardButton, numberField);
    }

    setStatus(card, cart, productId, addToCartCardButton, modalNumberField) {
        const product = cart.products.find(p => p.productItemId === parseInt(productId));

        if (product) {
            const addToCartButton = card.querySelector('.product-card__action--cart');
            const cardAmountSelector = card.querySelector('.product-card__amount-selector');
            const cardNumberField = card.querySelector('.product-card__amount-field');

            cardAmountSelector && cardAmountSelector.classList.toggle('product-card__amount-selector--hidden');
            addToCartButton && addToCartButton.classList.toggle('product-card__action--hidden');
            cardNumberField && (cardNumberField.value = product.amount);
            modalNumberField && (modalNumberField.value = product.amount);

            addToCartCardButton.classList.toggle('product-card__action--hidden');
        }
        else if (addToCartCardButton) {
            addToCartCardButton.classList.toggle('product-card__action--hidden');
        }
    }

    handleCardNumberValue = (card, modalNumberField, numberField, increase, productId) => {
        if (!numberField.dataset.initialValue) {
            numberField.dataset.initialValue = numberField.value;
        }
    
        const min = parseInt(numberField.getAttribute('min')) || 0;
        const max = parseInt(numberField.getAttribute('max')) || 99;
        const previousAmount = parseInt(numberField.dataset.initialValue) || min;
        const value = parseInt(numberField.value) || min;
    
        const fixedValue = Math.min(max, Math.max(min, increase ? value + 1 : value - 1));
        numberField.value = fixedValue;
        if (modalNumberField) modalNumberField.value = fixedValue;

        clearTimeout(this.handleCardNumberValueTimers.get(productId));
    
        this.handleCardNumberValueTimers.set(productId, setTimeout(() => {
            this.updateCartAfterAmountChanged(card, numberField.value, productId, previousAmount);
            numberField.dataset.initialValue = numberField.value; // Update initial value after timeout
        }, 1000));
    };
    

    enforceCardLimits = (card, numberField, productId) => {
        const min = parseInt(numberField.getAttribute('min')) || 0;
        const max = parseInt(numberField.getAttribute('max')) || 99;
        const value = parseInt(numberField.value);

        if (isNaN(value) || numberField.value.trim() === "") {
            numberField.value = min;
        } else {
            numberField.value = Math.min(max, Math.max(min, value));
        }

        clearTimeout(this.enforceCardLimitsTimers.get(productId));

        this.enforceCardLimitsTimers.set(productId, setTimeout(() => {
            this.updateCartAfterAmountChanged(card, numberField.value, productId);
        }, 1000));
    };

    updateCartAfterAmountChanged(card, amount, productId, previousAmount) {
        const self = this;
        fetch(`/api/v2/cart/update/${productId}/${amount}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
        })
            .then(response => {
                return response.json();
            })
            .then((response) => self.handleCartUpdated(response, previousAmount))
            .catch(error => console.error('Error:', error));
    }

    addToCart = (productId, cardNumberField, otherNumberField, amount, card = null, addToCartModalButton = null) => {
        const self = this;

        if (productId === NaN || amount === NaN || amount < 0)
            return;

        if (card) {
            card.classList.add('product-card--loading');
        }

        if (addToCartModalButton) {
            addToCartModalButton.classList.add('product-modal__action--loading');
        }

        fetch(`/api/v2/cart/update/${productId}/${amount}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
        })
            .then(response => {
                if (card) {
                    card.classList.add('product-card--added');
                    setTimeout(() => {
                        card.classList.remove('product-card--added');
                        card.classList.remove('product-card--loading');
                    }, 2500);
                }
                else if (otherNumberField) {
                    if (amount === '0') {
                        otherNumberField.parentElement.classList.add('product-card__amount-selector--hidden');
                        otherNumberField.parentElement.nextElementSibling.classList.remove('product-card__action--hidden')
                    }
                    else {
                        otherNumberField.parentElement.classList.remove('product-card__amount-selector--hidden');
                        otherNumberField.parentElement.nextElementSibling.classList.add('product-card__action--hidden')
                    }
                    otherNumberField.value = amount;
                }

                if (addToCartModalButton) {
                    addToCartModalButton.classList.add('product-modal__action--added');

                    setTimeout(() => {
                        addToCartModalButton.classList.remove('product-modal__action--added');
                        addToCartModalButton.classList.remove('product-modal__action--loading');
                    }, 2500);
                }
                return response.json();
            })
            .then(data => {
                cardNumberField.value = amount;
                setTimeout(() => {
                    if (card) {
                        const addToCartButton = card.querySelector('.product-card__action--cart');
                        const cardAmountSelector = card.querySelector('.product-card__amount-selector');
                        if (cardAmountSelector) {
                            const amountField = cardAmountSelector.querySelector('.product-card__amount-field');
                            amountField.value = data.products.find(p => p.productItemId === parseInt(productId)).amount;
                            cardAmountSelector.classList.toggle('product-card__amount-selector--hidden');
                        }
                        if (addToCartButton) {
                            addToCartButton.classList.toggle('product-card__action--hidden');
                        }
                    }

                }, 2500);
                self.handleCartUpdated(data, 0)
            })
            .catch(error => console.error('Error:', error));
    }

    handleCartUpdated = (cart, previousAmount) => {
        const totalAmount = cart.products.reduce((sum, product) => sum + product.amount, 0);
        const headerMobileCartElement = document.getElementById('header-cart-mobile');
        const headerCartElement = document.getElementById('header-cart');
        const stickyCartElement = document.getElementById('sticky-cart');

        const stickyCartProducts = parseInt(stickyCartElement?.dataset?.products || '0', 10) || 0;

        const bottomCart = document.getElementById('bottom-cart');
        const shouldAnimate = previousAmount === 0 && totalAmount > 0 && stickyCartProducts == 0;
    
        const cartAriaLabel = `Gå till kassan (${totalAmount} produkter)`;

        if (headerCartElement) {
            headerCartElement.dataset.products = totalAmount;
            headerCartElement.setAttribute('aria-label', cartAriaLabel);
            headerCartElement.classList.toggle('header__cart--animate', shouldAnimate);
        }
        if (stickyCartElement) {
            stickyCartElement.dataset.products = totalAmount;
            stickyCartElement.setAttribute('aria-label', cartAriaLabel);
            stickyCartElement.classList.toggle('sticky-cart--animate', shouldAnimate);

            if (shouldAnimate) {
                setTimeout(() => stickyCartElement.classList.remove('sticky-cart--animate'), 3100);
            }
        }
        if (headerMobileCartElement) {
            headerMobileCartElement.dataset.products = totalAmount;
            headerMobileCartElement.setAttribute('aria-label', cartAriaLabel);
            headerMobileCartElement.classList.toggle('header__cart--animate', shouldAnimate);
        }
        if (bottomCart) {
            bottomCart.classList.toggle('shop_page__cart--visible', totalAmount > 0);
        }
    };
    

    handleExpandableButtonOnClick = (expandableButton) => {
        const isVisible = expandableButton.classList.contains('product-modal__expandable-button--expanded');
        expandableButton.classList.toggle('product-modal__expandable-button--expanded');
        expandableButton.nextElementSibling?.setAttribute('aria-hidden', isVisible ? 'true' : 'false');
    }

    handleNumberValue = (numberField, cardNumberField, increase, card, productId) => {
        if (!numberField.dataset.initialValue) {
            numberField.dataset.initialValue = numberField.value;
        }
    
        const min = parseInt(numberField.getAttribute('min')) || 0;
        const max = parseInt(numberField.getAttribute('max')) || 99;
        const previousAmount = parseInt(numberField.dataset.initialValue) || min;
        const value = parseInt(numberField.value) || min;
    
        const fixedValue = Math.min(max, Math.max(min, increase ? value + 1 : value - 1));
        numberField.value = fixedValue;
        cardNumberField.value = fixedValue;
    
        clearTimeout(this.handleCardNumberValueTimers.get(productId));
    
        this.handleCardNumberValueTimers.set(productId, setTimeout(() => {
            this.updateCartAfterAmountChanged(card, fixedValue, productId, previousAmount);
            numberField.dataset.initialValue = numberField.value;
        }, 1000));
    };

    enforceLimits = (numberField) => {
        const min = parseInt(numberField.getAttribute('min')) || 0;
        const max = parseInt(numberField.getAttribute('max')) || 99;
        const value = parseInt(numberField.value);

        if (isNaN(value) || numberField.value.trim() === "") {
            numberField.value = min;
        } else {
            const fixedValue = Math.min(max, Math.max(min, value));
            numberField.value = fixedValue;
        }
    };

    setHash(hash) {
        location.hash = hash;
    }

    removeHash() {
        history.pushState("", document.title, window.location.pathname + window.location.search);
    }

    toggleModal = (modal, focusElement, numberField, modalButton, overlay) => {
        const isOpening = !modal.classList.contains('product-modal--visible');

        modal.classList.toggle('product-modal--visible');
        modal.setAttribute('aria-hidden', !isOpening);
        modalButton.setAttribute('aria-expanded', isOpening);

        if (focusElement)
            focusElement.focus();

        if (overlay) {
            if (isOpening) {
                this.setHash(modal.dataset.productid);
                modal._closeModal = () => this.toggleModal(modal, focusElement, numberField, modalButton, overlay);
                overlay.addEventListener('click', modal._closeModal);
            } else {
                this.removeHash();
                overlay.removeEventListener('click', modal._closeModal);
                modal._closeModal = null;
            }
        }
    };
}

document.addEventListener('DOMContentLoaded', () => {
    const products = [...document.querySelectorAll('.product-card')];
    if (products) {

        fetch('/api/v2/cart/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        })
            .then(response => {
                return response.json();
            })
            .then((cart) => products.forEach(card => new ProductModal(card, cart)))
            .catch(error => console.error('Error:', error));
        ;
    }
});
